import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useAssetsData } from '@/zustand/useAssetsData';
import { useAttendantData } from '@/zustand/useAttendantData';

function useAuthentication() {
  const { behavior_list } = useAssetsData((store) => store.assetsData);
  const token = useAttendantData((store) => store.token);
  const isAttendantFlow = behavior_list.attendant_flow === 'true';

  return isAttendantFlow && !token;
}

export const ProtectedRoute = ({ children }: any) => {
  const isNoAuthentication = useAuthentication();

  if (isNoAuthentication) {
    return <Navigate to="/enter-attendant-id" />;
  }
  return children;
};
